var _rect, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3748_5964",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8.74228e-7,
    width: 20,
    height: 20,
    transform: "rotate(90 20 8.74228e-07)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3748_5964)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75V6.875L11.875 3.75H5V16.25H15M11.25 3.75V7.5H15",
    stroke: "#949494",
    strokeWidth: 1.17,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.5V10.625H8.57125C8.67 10.625 8.75 10.705 8.75 10.8038V12.3213C8.75 12.3687 8.73117 12.4141 8.69765 12.4476C8.66412 12.4812 8.61866 12.5 8.57125 12.5H6.875ZM6.875 12.5V14.375M15.4169 10.625H13.9288C13.8813 10.625 13.8359 10.6438 13.8024 10.6774C13.7688 10.7109 13.75 10.7563 13.75 10.8038V12.5M13.75 12.5H15.4169M13.75 12.5V14.375M10.3125 10.625V14.375H12.0088C12.0562 14.375 12.1016 14.3562 12.1351 14.3226C12.1687 14.2891 12.1875 14.2437 12.1875 14.1963V10.8038C12.1875 10.7563 12.1687 10.7109 12.1351 10.6774C12.1016 10.6438 12.0562 10.625 12.0088 10.625H10.3125Z",
    stroke: "#949494",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.facfa6020511a2d401881815b9671258.svg";
export { ForwardRef as ReactComponent };